import React = require('react');
import { StyledInputText, StyledErrorFor } from './styled';

export interface IValidatableProps {
  defaultValue: string;
  disabled?: boolean;
  errorMessage: string;
  isValid: (oldValue: any, newValue: any) => boolean;
  onValid: (newValue: any) => void;
  value?: string;
}

export interface IValidatableState {
  valid: boolean;
  value: string;
}

export class ValidatableTextInput extends React.Component<
  IValidatableProps,
  IValidatableState
> {
  public constructor(props: IValidatableProps) {
    super(props);
    this.state = {
      value: this.props.defaultValue,
      valid: this.props.isValid(
        this.props.defaultValue,
        this.props.defaultValue
      )
    };
  }

  public componentDidUpdate(
    prevProps: IValidatableProps,
    prevState: IValidatableState
  ) {
    if (this.props.value !== prevProps.value) {
      this.onChange(this.props.value);
    }
  }

  private onChange = (newValue: any) => {
    if (this.props.isValid(this.state.value, newValue)) {
      this.setState({ value: newValue, valid: true });
      this.props.onValid(newValue);
      return;
    }
    this.setState({ value: newValue, valid: false });
  };

  public render() {
    return (
      <div>
        <StyledInputText
          type={'text'}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            this.onChange(event.target.value);
          }}
          value={this.state.value}
          style={
            this.state.valid
              ? { border: '1px solid #dadada' }
              : { border: '1px solid red' }
          }
          disabled={this.props.disabled}
        />
        <StyledErrorFor>
          {!this.state.valid ? this.props.errorMessage : ''}
        </StyledErrorFor>
      </div>
    );
  }
}
